import React, { ReactElement } from 'react'
import styled from 'styled-components'
import DocsButton from './DocsButton'

interface IProps {
  title: string
  subTitle?: string
  docsLink?: string
}

const HeaderContainer = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: 3px;
`

const HeaderTitleRow = styled.div`
  align-items: center;
  column-gap: 8px;
  display: flex;
`

const HeaderTitle = styled.span`
  color: var(--ink, #20242d);
  font-size: 18.5px;
  font-weight: 500;
  letter-spacing: 0;
  line-height: 1.18;
`

const HeaderSubtitle = styled.span`
  color: var(--text-muted, #707887);
  font-size: 12px;
  line-height: 1.45;
`

function PageHeader({ title, subTitle, docsLink = '' }: IProps): ReactElement {
  return <HeaderContainer>
    <HeaderTitleRow>
      <HeaderTitle>{title}</HeaderTitle>
      {docsLink && <DocsButton docsLink={docsLink}/>}
    </HeaderTitleRow>
    {subTitle && <HeaderSubtitle>{subTitle}</HeaderSubtitle>}
  </HeaderContainer>
}

export default PageHeader
